import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw45Handlers = [
  // 特集マスタ情報取得 /kymw45/getFeatureMasterInfo
  http.post(
    PlessService.SERVICE.getFeatureMasterInfo.url,
    async ({ request }) => {
      const req = await request;
//      return HttpResponse.json(getFeatureMasterInfoResponse0);
      return HttpResponse.json(getFeatureMasterInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 特集マスタ情報更新 /kymw45/updateFeatureMasterInfo
  http.post(
    PlessService.SERVICE.updateFeatureMasterInfo.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(updateFeatureMasterInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 通知受領担当一覧取得 /kymw45/getNotificationUserList
  http.post(
    PlessService.SERVICE.getNotificationUserList.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getNotificationUserListResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 承認フロー区分一覧取得 /kymw45/getApprovalFlowList
  http.post(
    PlessService.SERVICE.getApprovalFlowList.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getApprovalFlowListResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 固定特集情報マスタ取得 /kymw45/getFixFeatureForMasterInfo
  http.post(
    PlessService.SERVICE.getFixFeatureForMasterInfo.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getFixFeatureForMasterInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 固定特集一覧取得 /kymw45/getFixFeature
  http.post(
    PlessService.SERVICE.getFixFeature.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getFixFeatureResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 特集コピー用媒体一覧取得 /kymw45/getMediumListForFeatureCopy
  http.post(
    PlessService.SERVICE.getMediumListForFeatureCopy.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getMediumListForFeatureCopyResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 特集コピー実行 /kymw45/executeFeatureCopy
  http.post(
    PlessService.SERVICE.executeFeatureCopy.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(executeFeatureCopyResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 企画確定フラグ取得 /kymw45/getCatalogFixFlag
  http.post(
    PlessService.SERVICE.getCatalogFixFlag.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getCatalogFixFlagResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 媒体グループ区分取得 /kymw45/getMediumGroupDiv
  http.post(
    PlessService.SERVICE.getMediumGroupDiv.url,
    async ({ request }) => {
      const req = await request;
      return HttpResponse.json(getMediumGroupDivResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),
];

const getFeatureMasterInfoResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      ExclusiveDatetime: "20250101000000",
      FeatureMasterList: [
      {
        OrderCode: "2023250",
        DelivCatalogId: "20230901",
        MediumType: "001",
        MediumName: "ハピデリ",
        FeatureCode: "00100",
        FeatureName: "表紙",
        ApprovalFlowType: 0,
        ApprovalFlowTypeName: "通常承認",
        NotificationUserId: "00100001",
        NotificationUserName: "担当者A",
        TagList: [
          {
            TagId: "00000002",
            TagName: "タグ２"
          }
        ],
        PayeeSupplierList: [
          {
            PayeeSupplierCode: "000000",
            PayeeSupplierName: "凸版株式会社"
          }
        ],
        AssociatedCompanyId: "000000",
        AssociatedCompanyName: "XX関連会社",
        Remarks: "XXXX",
        PlannerSelectionFlag: "0",
        FeaturePerMediaFlag: "false"
      },
      {
        OrderCode: "2023250",
        DelivCatalogId: "20230901",
        MediumType: "001",
        MediumName: "ハピデリ",
        FeatureCode: "00101",
        FeatureName: "表紙",
        ApprovalFlowType: 0,
        ApprovalFlowTypeName: "通常承認",
        NotificationUserId: "00100002",
        NotificationUserName: "担当者B",
        TagList: [
          {
            TagId: "00000005",
            TagName: "タグ５"
          },
          {
            TagId: "00000006",
            TagName: "タグ６"
          },
        ],
        PayeeSupplierList: [
          {
            PayeeSupplierCode: "000000",
            PayeeSupplierName: "凸版株式会社"
          },
          {
            PayeeSupplierCode: "000000",
            PayeeSupplierName: "凸版株式会社"
          }
        ],
        AssociatedCompanyId: "000000",
        AssociatedCompanyName: "XX関連会社",
        Remarks: "XXXX",
        PlannerSelectionFlag: "1",
        FeaturePerMediaFlag: "true"
      },
      {
        OrderCode: "2023250",
        DelivCatalogId: "20230901",
        MediumType: "999",
        MediumName: "在庫限定",
        FeatureCode: "99900",
        FeatureName: "裏表紙",
        ApprovalFlowType: 0,
        ApprovalFlowTypeName: "通常承認",
        NotificationUserId: "00100001",
        NotificationUserName: "担当者A",
        TagList: [
          {
            TagId: "00000005",
            TagName: "タグ５"
          },
          {
            TagId: "00000001",
            TagName: "タグ１"
          },
        ],
        PayeeSupplierList: [
          {
            PayeeSupplierCode: "000000",
            PayeeSupplierName: "凸版株式会社"
          },
          {
            PayeeSupplierCode: "000000",
            PayeeSupplierName: "凸版株式会社"
          }
        ],
        AssociatedCompanyId: "",
        AssociatedCompanyName: "",
        Remarks: "XXXX",
        PlannerSelectionFlag: "0",
        FeaturePerMediaFlag: "true"
      },
      { // 企画支援活性用
        OrderCode: "2023250",
        DelivCatalogId: "20230901",
        MediumType: "003",
        MediumName: "ぐるめぐり",
        FeatureCode: "11111",
        FeatureName: "表紙",
        ApprovalFlowType: 0,
        ApprovalFlowTypeName: "通常承認",
        NotificationUserId: "00100003",
        NotificationUserName: "担当者C",
        TagList: [
          {
            TagId: "00000005",
            TagName: "タグ５"
          },
          {
            TagId: "00000001",
            TagName: "タグ１"
          },
        ],
        PayeeSupplierList: [
          {
            PayeeSupplierCode: "000000",
            PayeeSupplierName: "凸版株式会社"
          },
          {
            PayeeSupplierCode: "000000",
            PayeeSupplierName: "凸版株式会社"
          }
        ],
        AssociatedCompanyId: "",
        AssociatedCompanyName: "",
        Remarks: "XXXX",
        PlannerSelectionFlag: "0",
        FeaturePerMediaFlag: "true"
      }
    ]}
  }
};

const getFeatureMasterInfoResponse0 = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: []
  }
};
const updateFeatureMasterInfoResponse = {
  status: 'ok',
  message: '処理完了'
};

const getNotificationUserListResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: [
      {
        NotificationUserId: "00100001",
        NotificationUserName: "担当者A"
      },
      {
        NotificationUserId: "00100002",
        NotificationUserName: "担当者B"
      },
    ]
  }
};
const getApprovalFlowListResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        ApprovalFlowType: "0",
        ApprovalFlowTypeName: "通常承認"
      },
      {
        ApprovalFlowType: "1",
        ApprovalFlowTypeName: "特集付替"
      },
      {
        ApprovalFlowType: "2",
        ApprovalFlowTypeName: "バイヤー直承認"
      }
    ]
  }
};
const getFixFeatureForMasterInfoResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: [
      {
        OrderCode: "2023250",
        DelivCatalogId: "20230901",
        MediumType: "001",
        MediumName: "ハピデリ",
        FeatureCode: "00100",
        FeatureName: "表紙",
        ApprovalFlowType: 0,
        ApprovalFlowTypeName: "通常承認",
        NotificationUserId: "00100002",
        NotificationUserName: "担当者B",
        TagList: [
          {
            TagId: "00000005",
            TagName: "タグ５"
          },
          {
            TagId: "00000006",
            TagName: "タグ６"
          },
        ],
        PayeeSupplierList: [
          {
            PayeeSupplierCode: "000000",
            PayeeSupplierName: "凸版株式会社"
          },
          {
            PayeeSupplierCode: "000000",
            PayeeSupplierName: "凸版株式会社"
          }
        ],
        PlannerSelectionFlag: '0',
        AssociatedCompanyId: "000000",
        AssociatedCompanyName: "XX関連会社",
        Remarks: "XXXX",
        FeaturePerMediaFlag: "true"
      },
    ]
  }
};
const getFixFeatureResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: [
      {
        MediumType: "001",
        MediumName: "ハピデリ",
        FeatureCode: "001H1",
        FeatureName: "ハピデリ表紙",
        SeaqenceCode: "H1"
      },
      {
        MediumType: "001",
        MediumName: "ハピデリ",
        FeatureCode: "001H2",
        FeatureName: "ハピデリ裏表紙",
        SeaqenceCode: "H2"
      },
      {
        MediumType: "001",
        MediumName: "ハピデリ",
        FeatureCode: "00101",
        FeatureName: "得だ値ひろば",
        SeaqenceCode: "001"
      },
      {
        MediumType: "003",
        MediumName: "ぐるめぐり",
        FeatureCode: "003H1",
        FeatureName: "表紙",
        SeaqenceCode: "001"
      }
    ],
  },
};
const getMediumListForFeatureCopyResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      MediumList:
        [
          {
            CanCopy: true,
            MediumType: '110011',
            MediumName: 'PEACE企画媒体',
          },
          {
            CanCopy: true,
            MediumType: '110012',
            MediumName: 'EC限定',
          },
          {
            CanCopy: true,
            MediumType: '110013',
            MediumName: '在庫限定',
          },
          {
            CanCopy: true,
            MediumType: '110014',
            MediumName: '日用ざっか広場',
          },
          {
            CanCopy: false,
            MediumType: '110015',
            MediumName: 'ペットといっしょ',
          },
          {
            CanCopy: false,
            MediumType: '110016',
            MediumName: 'カワタキ・サンスター',
          },
          {
            CanCopy: false,
            MediumType: '110017',
            MediumName: 'コスメdeきれい',
          },
        ],
    },
  },
};
const executeFeatureCopyResponse = {
  status: 'ok',
  message: '処理完了'
};

const getCatalogFixFlagResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CatalogFixFlag: '0'
      // CatalogFixFlag: '1'
    }
  }
}

const getMediumGroupDivResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      // MediumGroupDiv: '10'
      MediumGroupDiv: '11'
    }
  }
}
